export default "__VITE_ASSET__0ea4a8b3__"